import React from 'react';
import {
  Box,
  TextField,
  Typography,
  Tooltip,
  IconButton,
  Alert
} from '@mui/material';
import HistoryIcon from '@mui/icons-material/History';

// Recibe onFieldChange(value, fieldName)
function AgentFormPromptSection({
  prompt,
  errors,
  onFieldChange,
  revertSuccessMessage,
  // No necesita agentExists ni onOpenHistory aquí, se manejan en AgentForm
}) {
  return (
    <Box>
      {/* Botón de Historial (renderizado condicionalmente en AgentForm) */}
      {/* El AccordionSummary ahora vive en AgentForm */} 
      
      {/* Mensaje de éxito después de revertir */} 
      {revertSuccessMessage && (
        <Alert severity="success" sx={{ mb: 1.5 }}>
          {revertSuccessMessage}
        </Alert>
      )}
      <TextField
        label="Prompt del Agente"
        multiline
        rows={10}
        fullWidth
        value={prompt}
        onChange={(e) => onFieldChange(e.target.value, 'prompt')}
        required
        error={!!errors.prompt}
        helperText={errors.prompt || "Introduce el prompt del agente aquí..."}
        sx={{ 
          '& .MuiInputBase-root': {
            fontFamily: 'monospace',
            fontSize: '0.9rem'
          }
        }}
      />
    </Box>
  );
}

export default AgentFormPromptSection; 